import { render, staticRenderFns } from "./FreelySnackbar.vue?vue&type=template&id=18b7c18b&scoped=true&"
import script from "./FreelySnackbar.vue?vue&type=script&lang=js&"
export * from "./FreelySnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7c18b",
  null
  
)

export default component.exports